import React from "react";
import Button from "../../_components/button/Button";
import { CheckCircleIcon } from "@heroicons/react/outline";
import axios from "axios";

const Newsletter = () => {
  const [emailValue, setEmailValue] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [errorEmail, setErrorEmail] = React.useState({});

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const emailValidation = () => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!emailValue || regex.test(emailValue) === false) {
      setErrorEmail({ status: "error", message: "Email is not valid!" });

      return false;
    }
    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // forceUpdate();
    if (emailValidation()) {
      const formData = new FormData();
      formData.append("MERGE0", emailValue);
      formData.append("MERGE11", "YES");
      formData.append("MERGE5", "Customer");
      axios
        .post(
          "https://paradigm.us8.list-manage.com/subscribe/post-json?u=61f5f74dcd27c09fd132b2b69&id=0864d165e0&c=?",
          formData
        )
        .then((response) => {
          // console.log(response.data);
          const success = response.data.includes(
            "Thank you for subscribing" || "success"
          );
          const exists = response.data.includes(
            "already subscribed to list" || "error"
          );
          if (success) {
            setSubmitted(true);
          } else if (exists) {
            setErrorEmail({
              status: "error",
              message: "You're already subscribed.",
            });
          } else if (!success && !exists) {
            setErrorEmail({
              status: "error",
              message: "Something went wrong!",
            });
          }
        })
        .catch((err) => {
          if (err) {
            setErrorEmail({
              status: "error",
              message: "Something went wrong!",
            });
          }
        })
        .finally(() => {
          if (submitted) {
            resetForm();
          }

          // setTimeout(() => {
          //   setErrorEmail({});
          // }, 2000);
        });
    }
  };

  const resetForm = () => {
    document.getElementById("myForm").reset();
  };

  return (
    <section className="z-50 relative bg-gray-600 flex  justify-center  pt-4 px-4 pb-11 text-left lg:text-center  sm:p-0">
      <div className="inline-block align-bottom  px-4 pt-5 pb-4  overflow-hidden qqsm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-16">
        {!submitted ? (
          <>
            <div className="mt-3 sm:mt-5">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-left lg:text-center text-white leading-snug">
                Connect With Us
              </h2>
              <p className="mt-3 max-w-3xl text-sm leading-6 text-gray-50">
                Enter your email for updates on products and breaking news.
              </p>
            </div>
            <div className="mt-5 sm:mt-6">
              <div className="mt-8 sm:w-full sm:max-w-lg xl:mt-0 xl:ml-8">
                <form id="myForm" className="sm:flex">
                  <label htmlFor="MERGE0" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="MERGE0"
                    name="MERGE0"
                    type="email"
                    required
                    // className="w-full border-white mt-0 p-3 h-9 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-black focus:ring-white rounded-md"

                    className={classNames(
                      !errorEmail.length
                        ? "w-full border-white mt-0 p-3 h-9 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-black focus:ring-white rounded-md"
                        : "w-full  px-5 py-3 rounded-md mb-3 border-red-300 text-red-700 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500"
                    )}
                    placeholder="Enter your email"
                    onChange={(e) => {
                      // setErrorEmail("");
                      setEmailValue(e.target.value);
                    }}
                  />

                  <button
                    type="button"
                    name="submit"
                    value="Subscribe"
                    id="mc-embedded-subscribe"
                    className="mt-3  flex items-center justify-center  sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0"
                    onClick={handleSubmit}
                    disabled={!emailValue.length}
                  >
                    <Button
                      name={"Notify me"}
                      dark={true}
                      centered={false}
                      width={"fit"}
                    />
                  </button>
                </form>

                {Object.keys(errorEmail) && "status" in errorEmail ? (
                  <div className="text-red-500 bg-white pt-1 mt-3">
                    {errorEmail.message}
                  </div>
                ) : null}

                <p className="mt-3 text-sm text-gray-50">
                  We care about the protection of your data. Read our{" "}
                  <a
                    className="text-gray-50 font-medium underline"
                    href="https://www.anthemav.com/support/privacy.php"
                    target="_blank"
                  >
                    Privacy Policy.
                  </a>
                </p>
              </div>
            </div>{" "}
          </>
        ) : (
          <div className="text-left lg:text-center m-auto ">
            {" "}
            <div className="lg:mx-48 sm:mx-0 mx-0">
              <CheckCircleIcon
                className="text-green-400 h-36 w-36 "
                aria-hidden="true"
              />
            </div>
            <p className="mt-6 max-w-3xl text-3xl font-bold leading-6 text-gray-50">
              You're in.
            </p>
            <p className="mt-6 text-2xl leading-6 text-gray-50">
              Thank you for being a subscriber.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Newsletter;
